import React from 'react';

// Hairline line-art icons for the technician portal's tab bar and headers.
// Drawn to match the QPS seal: 1.5px strokes, no fills, currentColor so the
// tab bar can tint them camel when active. Inline SVG rather than an icon
// package — the brand rules out emojis, and this is a handful of shapes.

const Svg = ({ size = 22, children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true" style={{ flexShrink: 0 }}>
    {children}
  </svg>
);

// Overview — a roof and a door. Drawn on the same 24px grid and the same
// stroke weight as the rest, so the bar does not have one odd tab in it.
export const IconHome = (p) => (
  <Svg {...p}>
    <path d="M3 10.5L12 3.5l9 7" />
    <path d="M5.5 9.8V20h13V9.8" />
    <path d="M10 20v-5h4v5" />
  </Svg>
);

// Jobs — a toolbox.
export const IconJobs = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="7.5" width="19" height="12" rx="2" />
    <path d="M9 7.5V6a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 6v1.5" />
    <path d="M2.5 12.5h19M10.5 12.5v2h3v-2" />
  </Svg>
);

// Properties — a row of buildings, for the Commercial Accounts tab bar. A
// portfolio, not a house: the homeowner side owns one roof, this side owns
// four hundred.
export const IconProperties = (p) => (
  <Svg {...p}>
    <path d="M3 21V9.5L9 6l6 3.5V21" />
    <path d="M15 21V12l6 3.5V21" />
    <path d="M6.5 12h2M6.5 15.5h2M11 12h1M11 15.5h1M18 18h.5" />
    <path d="M2 21h20" />
  </Svg>
);

// Team — the people on an account.
export const IconTeam = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.25" />
    <path d="M2.75 20a6.25 6.25 0 0 1 12.5 0" />
    <path d="M16 5.5a3.25 3.25 0 0 1 0 6.4" />
    <path d="M17.5 14.4A6.25 6.25 0 0 1 21.25 20" />
  </Svg>
);

// Estimates — a calculator, as in Joist's tab bar.
export const IconEstimates = (p) => (
  <Svg {...p}>
    <rect x="4.5" y="2.5" width="15" height="19" rx="2" />
    <rect x="7.5" y="5.5" width="9" height="3.5" rx="0.5" />
    <path d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01M16 17h.01" />
  </Svg>
);

// Invoices — a document with lines.
export const IconInvoices = (p) => (
  <Svg {...p}>
    <path d="M6 2.5h7.5L19 8v13.5H6z" />
    <path d="M13.5 2.5V8H19" />
    <path d="M9 12.5h7M9 16h7M9 9h2" />
  </Svg>
);

// Payments — a card.
export const IconPayments = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="5.5" width="19" height="13" rx="2" />
    <path d="M2.5 10h19M6 14.5h3" />
  </Svg>
);

// More — the three dots.
export const IconMore = (p) => (
  <Svg {...p}>
    <circle cx="5" cy="12" r="1.1" />
    <circle cx="12" cy="12" r="1.1" />
    <circle cx="19" cy="12" r="1.1" />
  </Svg>
);

export const IconBell = (p) => (
  <Svg {...p}>
    <path d="M18 8.5a6 6 0 1 0-12 0c0 6-2 7.5-2 7.5h16s-2-1.5-2-7.5" />
    <path d="M13.7 19.5a2 2 0 0 1-3.4 0" />
  </Svg>
);

export const IconPlus = (p) => (
  <Svg {...p}><path d="M12 5.5v13M5.5 12h13" /></Svg>
);

export const IconSearch = ({ size = 16 }) => (
  <Svg size={size}><circle cx="11" cy="11" r="6.5" /><path d="M16 16l4.5 4.5" /></Svg>
);

export const IconChevron = ({ size = 18 }) => (
  <Svg size={size}><path d="M9.5 6l6 6-6 6" /></Svg>
);

// The three ways to reach a client from their own page — an envelope, a
// handset and a speech bubble, sitting beside the address they belong to.
export const IconMail = ({ size = 20 }) => (
  <Svg size={size}>
    <rect x="2.5" y="5" width="19" height="14" rx="2" />
    <path d="M3 6.5l9 6.5 9-6.5" />
  </Svg>
);

export const IconPhone = ({ size = 20 }) => (
  <Svg size={size}>
    <path d="M8 3.5l2.2 4-2 2a12 12 0 0 0 6.3 6.3l2-2 4 2.2v3A1.5 1.5 0 0 1 19 20.5C10.4 20.1 3.9 13.6 3.5 5A1.5 1.5 0 0 1 5 3.5z" />
  </Svg>
);

export const IconMessage = ({ size = 20 }) => (
  <Svg size={size}>
    <path d="M20.5 12.5c0 3.6-3.8 6.5-8.5 6.5a10 10 0 0 1-2.7-.36L4.5 20.5l1.2-3.1A6.9 6.9 0 0 1 3.5 12.5C3.5 8.9 7.3 6 12 6s8.5 2.9 8.5 6.5z" />
  </Svg>
);
